import React from "react"
import styled from "styled-components"

import AnimatedWindowProvider from "context/window/AnimatedWindowProvider"

import TitleHeader from "components/presenters/header/TitleHeader"
// import OrderHistory from "components/containers/commerce/order/OrderHistory"
import OrderHistoryContainer from "components/containers/commerce/order/OrderHistoryContainer"

export default function OrderHistoryLayout() {
  return (
    <AnimatedWindowProvider>
      <Layout>
        <LayoutHeader>
          <TitleHeader title={"주문내역"} />
        </LayoutHeader>
        <LayoutBody>
          <OrderHistoryContainer />
        </LayoutBody>
      </Layout>
    </AnimatedWindowProvider>
  )
}

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`

export const LayoutHeader = styled.div`
  min-height: calc(100vw * (51 / 375));
  flex: 0 1 auto;
`
export const LayoutBody = styled.div`
  flex: 1 1 auto;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: calc(100vw * (11.5 / 375));
  overflow: hidden;
`
